import type { SxProps, Theme } from '@mui/material';

// Landing Page Styles
export const landingContainer: SxProps<Theme> = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    padding: 3,
};

export const landingCard: SxProps<Theme> = {
    maxWidth: 700,
    width: '100%',
    padding: 6,
    borderRadius: 4,
    textAlign: 'center',
    background: 'white',
    boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
};

export const landingTitle: SxProps<Theme> = {
    color: '#4169E1',
    fontWeight: 700,
    marginBottom: 2,
    fontSize: { xs: '1.75rem', sm: '2.125rem' },
};

export const landingSubtitle: SxProps<Theme> = {
    color: '#666',
    marginBottom: 4,
    fontSize: { xs: '0.95rem', sm: '1rem' },
};

export const startButton: SxProps<Theme> = {
    backgroundColor: '#4169E1',
    color: 'white',
    padding: '14px 60px',
    borderRadius: 50,
    fontSize: '1.1rem',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 8px 16px rgba(65,105,225,0.3)',
    '&:hover': {
        backgroundColor: '#3557c9',
        boxShadow: '0 12px 24px rgba(65,105,225,0.4)',
        transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
};

// Camera Capture Styles
export const captureContainer: SxProps<Theme> = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    // padding: { xs: 2, sm: 3 },
};

export const captureContent: SxProps<Theme> = {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 3,
    maxWidth: 1200,
    width: '100%',
};

export const cameraSection: SxProps<Theme> = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
};

export const videoContainer: SxProps<Theme> = {
    position: 'relative',
    width: '100%',
    maxWidth: 600,
    aspectRatio: '4/3',
    borderRadius: 3,
    overflow: 'hidden',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    backgroundColor: '#000',
};

export const videoElement: SxProps<Theme> = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};

export const overlayContainer: SxProps<Theme> = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
};

export const instructionsPanel: SxProps<Theme> = {
    flex: { xs: 'unset', md: 1 },
    maxWidth: { xs: '100%', md: 400 },
    padding: 4,
    backgroundColor: 'white',
    borderRadius: 3,
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
};

export const stepIndicator: SxProps<Theme> = {
    color: '#999',
    fontSize: '0.875rem',
    fontWeight: 600,
    marginBottom: 1,
    letterSpacing: '0.5px',
};

export const stepTitle: SxProps<Theme> = {
    color: '#333',
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: 3,
};

export const stepDescription: SxProps<Theme> = {
    color: '#666',
    marginBottom: 3,
    lineHeight: 1.6,
};

export const instructionLabel: SxProps<Theme> = {
    color: '#333',
    fontWeight: 700,
    marginBottom: 2,
    fontSize: '1.1rem',
};

export const instructionItem: SxProps<Theme> = {
    marginBottom: 2,
    '& strong': {
        color: '#333',
        fontWeight: 700,
    },
};

export const instructionText: SxProps<Theme> = {
    color: '#666',
    lineHeight: 1.6,
};

export const buttonContainer: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    marginTop: 'auto',
    flexDirection: { xs: 'column', sm: 'row' },
};

export const backButtonStyle: SxProps<Theme> = {
    flex: 1,
    padding: '12px 24px',
    borderRadius: 50,
    textTransform: 'none',
    fontSize: '1rem',
    fontWeight: 600,
    borderColor: '#ddd',
    color: '#666',
    '&:hover': {
        borderColor: '#999',
        backgroundColor: 'rgba(0,0,0,0.02)',
    },
};

export const scanButton: SxProps<Theme> = {
    flex: 2,
    backgroundColor: '#4169E1',
    color: 'white',
    padding: '12px 24px',
    borderRadius: 50,
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 12px rgba(65,105,225,0.3)',
    '&:hover': {
        backgroundColor: '#3557c9',
        boxShadow: '0 6px 16px rgba(65,105,225,0.4)',
    },
    '&:disabled': {
        backgroundColor: '#ccc',
        color: '#999',
    },
};

// Error/Loading Styles
export const errorContainer: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    textAlign: 'center',
    minHeight: 400,
};

export const errorText: SxProps<Theme> = {
    color: '#d32f2f',
    marginTop: 2,
    fontSize: '1.1rem',
};

export const loadingContainer: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    minHeight: 400,
    gap: 2,
};